import { render, staticRenderFns } from "./product-input.vue?vue&type=template&id=16c775f5&scoped=true&"
import script from "./product-input.vue?vue&type=script&lang=js&"
export * from "./product-input.vue?vue&type=script&lang=js&"
import style0 from "./product-input.vue?vue&type=style&index=0&id=16c775f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c775f5",
  null
  
)

export default component.exports